/* tslint:disable */
/* eslint-disable */
/**
 * Dashboard Service
 * This is the API documentation of the Dashboard service
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ParkRepresentation
 */
export interface ParkRepresentation {
    /**
     * 
     * @type {string}
     * @memberof ParkRepresentation
     */
    key: string;
    /**
     * 
     * @type {string}
     * @memberof ParkRepresentation
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof ParkRepresentation
     */
    zipCode?: string;
}

/**
 * Check if a given object implements the ParkRepresentation interface.
 */
export function instanceOfParkRepresentation(value: object): value is ParkRepresentation {
    if (!('key' in value) || value['key'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function ParkRepresentationFromJSON(json: any): ParkRepresentation {
    return ParkRepresentationFromJSONTyped(json, false);
}

export function ParkRepresentationFromJSONTyped(json: any, ignoreDiscriminator: boolean): ParkRepresentation {
    if (json == null) {
        return json;
    }
    return {
        
        'key': json['key'],
        'name': json['name'],
        'zipCode': json['zipCode'] == null ? undefined : json['zipCode'],
    };
}

export function ParkRepresentationToJSON(json: any): ParkRepresentation {
    return ParkRepresentationToJSONTyped(json, false);
}

export function ParkRepresentationToJSONTyped(value?: ParkRepresentation | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'key': value['key'],
        'name': value['name'],
        'zipCode': value['zipCode'],
    };
}

